import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { getFilenameFromHeader } from '../../utils/get-filename-header'
import { getAPIUrl } from '../API'
import { DownloadFileResult } from '../shared/downloadFile'

interface VerifyIdProps {
  body: Record<string, any>
}

export const loadReport = async (props: VerifyIdProps) => {
  const { body } = props
  const headers: Record<string, string> = {
    Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    'Content-Type': 'application/json',
  }
  const url = `${getAPIUrl()}/RealTimeIDV/load-report`
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    return null
  }
  const data = await res.json()
  return data
}
export const DownloadRealtimeReport = async (
  props: VerifyIdProps,
): Promise<DownloadFileResult | null> => {
  const { body } = props
  const headers: Record<string, string> = {
    Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    'Content-Type': 'application/json',
  }
  const url = `${getAPIUrl()}/RealTimeIDV/download-report`
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    return null
  }
  const filename = getFilenameFromHeader(res.headers.get('Content-Disposition'))
  const blob = await res.blob()
  return {
    filename,
    blob,
  }
}
